import { useEffect, useState } from "react";
import { CustomDataGrid } from "../../../components/CustomDataGrid";
import { GridColDef } from "@mui/x-data-grid";
import axios from "axios";
import { baseURL } from "../../../config/api";
import moment from "moment";
import { getStatusColor } from "../../../utils/functionHelper";
import { Link } from "react-router-dom";
import { formatUSPhone } from "../../../utils/phoneFormatter";


type TodaysWheelChangeServiceProps = {
    date: string;
    serviceId: number;
    locationId: number;
}

export const TodaysWheelChangeService = ({ date, serviceId, locationId }: TodaysWheelChangeServiceProps) => {
    const [filterData, setFilterData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);

    const columns: GridColDef[] = [
        {
            field: "serviceNumber",
            headerName: "Service Number",
            editable: false,
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                return (
                    <Link to={`/admin/services/editservice?id=${params?.row?.appointmentId}`} className="underline text-[#0000ff]">
                        {params?.value}
                    </Link>
                )
            }
        },
        {
            field: "timeSlot",
            headerName: "Time",
            editable: false,
            sortable: false,
            flex: 1
        },
        {
            field: "firstName",
            headerName: "First Name",
            editable: false,
            sortable: false,
            flex: 1
        },
        {
            field: "lastName",
            headerName: "Last Name",
            editable: false,
            sortable: false,
            flex: 1
        },
        {
            field: "email",
            headerName: "Email",
            editable: false,
            sortable: false,
            flex: 1
        },
        {
            field: "phone",
            headerName: "Phone",
            editable: false,
            sortable: false,
            flex: 1,
            renderCell: (params) =>
                params.value ? formatUSPhone(params.value) : ""
        },
        {
            field: "status",
            headerName: "Status",
            editable: false,
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                const color = getStatusColor(params.value);
                return (
                    <div className="flex items-end h-full">
                        <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
                            {params.value}
                        </span>
                    </div>
                );
            }
        }
    ];



    useEffect(() => {
        if (locationId > 0) {
            if (date && serviceId && searchValue === "") {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');

                axios
                    .get(`${baseURL}dailyManifest/GetAppointmentByLocationIdAndServiceIdAndDate/${locationId},${serviceId},${formatDateString}`)
                    .then((response) => {
                        const result = response?.data?.map((item: any, index: number) => {
                            return {
                                ...item,
                                id: index,
                                appointmentDate: moment(new Date(item?.appointmentDate)).format("MM/DD/YYYY"),
                                timeSlot: moment(item?.timeSlot, "HH:mm").format("hh:mm A")
                            }
                        })

                        setFilterData(result);
                        setLoading(false);

                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        }
        else {
            if (date && serviceId && searchValue === "") {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');

                axios
                    .get(`${baseURL}dailyManifest/GetAppointmentByServiceIdAndDate/${serviceId},${formatDateString}`)
                    .then((response) => {
                        const result = response?.data?.map((item: any, index: number) => {
                            return {
                                ...item,
                                id: index,
                                appointmentDate: moment(new Date(item?.appointmentDate)).format("MM/DD/YYYY"),
                                timeSlot: moment(item?.timeSlot, "HH:mm").format("hh:mm A")
                            }
                        })

                        setFilterData(result);
                        setLoading(false);

                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date, locationId, serviceId, searchValue]);

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue.trim() !== "") {
            timeOutId = setTimeout(() => {

                filterDataApi(searchValue.trim());
            }, 1000);
        }

        return () => clearTimeout(timeOutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    const filterDataApi = (search: string) => {
        setLoading(true);
        const updatedDate = moment(date).endOf('day');
        let formatDateString = updatedDate.format('YYYY-MM-DD');

        if (locationId > 0) {
            axios
                .get(`${baseURL}dailyManifest/GetAppointmentByLocationIdAndServiceIdAndDateAndSearch?locationId=${locationId}&search=${search}&serviceId=${serviceId}&date=${formatDateString}`)
                .then((response) => {
                    const result = response?.data?.map((item: any, index: number) => {
                        return {
                            ...item,
                            id: index,
                            appointmentDate: moment(new Date(item?.appointmentDate)).format("MM/DD/YYYY"),
                            timeSlot: moment(item?.timeSlot, "HH:mm").format("hh:mm A")
                        }
                    })

                    setFilterData(result);
                    setLoading(false);

                })
                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            axios
                .get(`${baseURL}dailyManifest/GetAppointmentByServiceIdAndDateAndSearch?search=${search}&serviceId=${serviceId}&date=${formatDateString}`)
                .then((response) => {
                    const result = response?.data?.map((item: any, index: number) => {
                        return {
                            ...item,
                            id: index,
                            appointmentDate: moment(new Date(item?.appointmentDate)).format("MM/DD/YYYY"),
                            timeSlot: moment(item?.timeSlot, "HH:mm").format("hh:mm A")
                        }
                    })

                    setFilterData(result);
                    setLoading(false);

                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }


    return (
        <div className={`w-full border  rounded-[16px]`}>
            <div className={`flex justify-between items-center p-4 border-b `}>

                <h2 className={`text-lg font-semibold`}>Today's Wheel Change Service</h2>

                <div className={`w-[30%] flex px-[5px] py-[6px] items-center gap-2.5 rounded-lg border  shadow-sm`}>
                    <span className={`material-symbols-outlined text-[25px] font-light`}>
                        search
                    </span>
                    <input
                        type="text"
                        placeholder="Service No, Name, Email or Phone"
                        className={`border-none outline-none w-full bg-transparent text-sm`}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                    />
                </div>
            </div>

            <CustomDataGrid
                filteredRows={filterData}
                columns={columns}
                loading={loading}
            />
        </div>
    )
}